import {
	TableContainer as TableContainerMui,
	TableContainerProps,
} from '@mui/material';

import { forwardRef } from 'react';
import styled from 'styled-components';

const StyledTableContainer = styled(TableContainerMui)<TableContainerProps>`
	width: 100%;
	&::-webkit-scrollbar {
		height: 8px;
		width: 8px;
		border-radius: 6px;
		border: none;
	}
	&::-webkit-scrollbar-track {
		background-color: white;
		border-radius: 6px;
	}
	&::-webkit-scrollbar-thumb {
		border-radius: 6px;
		height: 8px;
		width: 8px;
		background-color: #031434;
	}
`;

const TableContainer = forwardRef<HTMLDivElement, TableContainerProps>(
	(props, ref) => {
		return (
			<StyledTableContainer ref={ref} {...props}>
				{props.children}
			</StyledTableContainer>
		);
	},
);

export default TableContainer;
